export enum AdminRoleId {
    SuperAdmin = 99,
    Admin = 98,
    CanSeeReports = 97,
    CanUploadVideos = 96,
    CanPostArticles = 95,
    Affiliate = 94,
    FreeAccount = 93
}
